<template>
  <div>
    <el-dialog class="del-dialog" :visible.sync="currentValue" width="422px" title="提示" :close-on-click-modal="false">
      <div class="del-dialog-msg">
        <p>
          <img src="image/icon/warning.png" alt="" />
          <span>{{ title }}</span>
        </p>
        <p>{{ tip }}</p>
      </div>
      <div class="rest-name-btns">
        <wf-button plain style="margin-right: 24px" @click="currentValue = false">取消</wf-button>
        <wf-button @click="check">确定</wf-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ["value", "title", "tip"],
  computed: {
    currentValue: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    check() {
      this.$emit("check");
    },
  },
};
</script>
<style lang="scss">
.del-dialog {
  .el-dialog__header {
    border-bottom: 0 none;
  }
  .del-dialog-msg {
    i {
      font-size: 20px;
      margin-right: 8px;
    }
    p:first-child {
      font-size: 18px;
      color: #ff3939;
      display: flex;
      align-items: center;
      img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }
    p:last-child {
      font-size: 14px;
      color: rgba(32, 32, 32, 0.6);
      margin-top: 16px;
      padding-left: 30px;
    }
  }
  .rest-name-btns {
    margin-top: 48px;
    display: flex;
    justify-content: flex-end;
  }
  .el-dialog__body {
    padding-top: 14px;
  }
}
</style>
